import React from "react";

const Label = ({ displayAble, className = "body-medium-regular" }) => {
  if (Array.isArray(displayAble)) {
    return <>{displayAble.map((item) => {
      if (typeof item === 'object' && item !== null) {
        return <div className={`${className} ${item.class_name}`}>{item.text}</div>
      }
      return <div className={className}>{item}</div>
    })}</>;
  }
  return <div className={className}>{displayAble}</div>;
};

const SimpleTableItem = ({
  props,
  subTextPropKey,
  textPropKey,
  urlPropKey
}) => {
  const hasSubText = !!props[subTextPropKey];
  const labelClassName = hasSubText ? "body-medium-semibold" : "body-medium-regular";
  return (
    <div>
      <div>
        {urlPropKey ? (
          <a href={props[urlPropKey]}>
            <Label
              className={labelClassName}
              displayAble={props[textPropKey]}
            />
          </a>
        ) : (
          <Label
            className={labelClassName}
            displayAble={props[textPropKey]}
          />
        )}
      </div>
      {hasSubText && (
        <Label
          displayAble={props[subTextPropKey]}
        />
      )}
    </div>
  );
};

export default SimpleTableItem;